import { CareJourneyRoadmapSkeleton } from "../../../components/CareJourneyRoadmap/CareJourneyRoadmapSkeleton";

interface AppointmentDetailSkeletonProps {
  /** Whether the page will show the care journey, so its band is held too. */
  showJourney?: boolean;
}

/**
 * Stands in for the whole appointment page while its sections load, laid out
 * like the real page so the swap moves as little as possible.
 */
export const AppointmentDetailSkeleton = ({
  showJourney = false,
}: AppointmentDetailSkeletonProps) => (
  <div
    className="appointment-detail__skeleton placeholder-wave"
    aria-busy="true"
    aria-label="Loading appointment"
  >
    <div className="appointment-detail__layout">
      <div className="appointment-detail__main">
        <div className="appointment-detail__top">
          {/* A simplified AppointmentHero, using its layout classes so the spacing matches. */}
          <div className="appointment-hero">
            <div className="appointment-hero__when">
              <div>
                <div className="appointment-hero__date">
                  <span className="placeholder appointment-skeleton__date" />
                </div>
              </div>
              <div className="appointment-hero__time-block">
                <span className="placeholder appointment-skeleton__time" />
                <span className="placeholder appointment-skeleton__until" />
              </div>
            </div>
            <div className="appointment-hero__body">
              <span className="placeholder appointment-skeleton__pill" />
              <span className="placeholder appointment-skeleton__title" />
              <div className="appointment-hero__center">
                <span className="placeholder appointment-skeleton__mode" />
                <div className="appointment-hero__coach">
                  <span className="placeholder appointment-hero__avatar" />
                  <span className="placeholder appointment-skeleton__name" />
                </div>
              </div>
              <div className="appointment-hero__actions">
                <span className="placeholder appointment-skeleton__button" />
              </div>
            </div>
          </div>
          <section className="appointment-card appointment-skeleton__history">
            <span className="placeholder appointment-skeleton__heading" />
            {Array.from({ length: 3 }).map((_, index) => (
              <span className="placeholder appointment-skeleton__row" key={index} />
            ))}
          </section>
        </div>
        {showJourney && (
          <div className="appointment-detail__journey">
            <CareJourneyRoadmapSkeleton title="Care Journey" />
          </div>
        )}
        <section className="appointment-card appointment-detail__summary appointment-skeleton__summary">
          <span className="placeholder appointment-skeleton__heading" />
          {Array.from({ length: 4 }).map((_, index) => (
            <span className="placeholder appointment-skeleton__row" key={index} />
          ))}
        </section>
      </div>
      <div className="appointment-detail__sidebar">
        <section className="appointment-card appointment-notifications">
          <span className="placeholder appointment-skeleton__heading" />
          <span className="placeholder appointment-skeleton__row" />
          <span className="placeholder appointment-skeleton__row" />
        </section>
      </div>
    </div>
  </div>
);
